// extracted by mini-css-extract-plugin
module.exports = {"closeIcon":"closeButton_closeIcon__1EfzW"};